import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { validateAdminPassword, getAdminToken, clearAdminToken, onSessionExpired } from '../services/adminService';

// Deliberately sessionStorage, not localStorage: this is a privileged internal
// tool (per Martin's team), so the session should not silently persist across
// browser restarts on a shared/public machine the way the customer PIN session does.
const SESSION_KEY = 'admin_session';

const AdminPage: React.FC = () => {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    // A session is only real if the token that backs it is still here — the
    // flag alone would survive the token being cleared or expiring.
    setAuthenticated(sessionStorage.getItem(SESSION_KEY) === 'true' && !!getAdminToken());

    // Any admin call that comes back unauthorised drops us here.
    return onSessionExpired(() => {
      sessionStorage.removeItem(SESSION_KEY);
      setAuthenticated(false);
      setExpired(true);
    });
  }, []);

  const handleSuccess = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setExpired(false);
    setAuthenticated(true);
  };

  const handleLogout = async () => {
    sessionStorage.removeItem(SESSION_KEY);
    await clearAdminToken();  // revokes it server-side, not just locally
    setAuthenticated(false);
  };

  if (!authenticated) {
    return (
      <>
        {expired && (
          <div className="fixed top-4 inset-x-0 z-50 flex justify-center px-4">
            <p className="bg-amber-500/15 border border-amber-500/40 text-amber-300 text-sm rounded-lg px-4 py-2">
              Tu sesión expiró (duran 8 horas). Vuelve a entrar.
            </p>
          </div>
        )}
        <AdminLogin onValidate={validateAdminPassword} onSuccess={handleSuccess} />
      </>
    );
  }

  return <AdminDashboard onLogout={handleLogout} />;
};

export default AdminPage;
